import { useTranslation } from "react-i18next";
import DownloadCardGrid from "./DownloadCardGrid";
import ScrollDownIndicator from "./ScrollDownIndicator";
import "../styles/Downloads.css";

export default function DirectionCommitteePageComponent() {
    const { t } = useTranslation();

    const directionCommitteeData = [
        {
            title: "Calmuc Marius Daniel",
            image: "/DownloadDocuments/Directions/Comitet de Directie/ASR - Calmuc Marius Daniel - Damen - Foto.jpg",
            downloadTitle: "download_cv_title",
            downloadLinks: [{
                name: "download_name_pdf",
                url: "/DownloadDocuments/Directions/Comitet de Directie/ASR - Calmuc Marius Daniel - Damen - CV.pdf",
            }],
        },
        {
            title: "Cristian Popa",
            image: "/DownloadDocuments/Directions/Comitet de Directie/ASR - Cristian Popa - Greenbier - Foto.JPG",
            downloadTitle: "download_cv_title",
            downloadLinks: [{
                name: "download_name_pdf",
                url: "/DownloadDocuments/Directions/Comitet de Directie/ASR - Cristian Popa - Greenbier - CV.pdf",
            }],
        },
        {
            title: "Feier Anamaria",
            image: "/DownloadDocuments/Directions/Comitet de Directie/ASR - Feier Anamaria - Foto.jpg",
            downloadTitle: "download_cv_title",
            downloadLinks: [{
                name: "download_name_pdf",
                url: "/DownloadDocuments/Directions/Comitet de Directie/ASR - Feier Anamaria - CV.pdf",
            }],
        },
        {
            title: "Savu Sorin Vasile",
            image: "/DownloadDocuments/Directions/Comitet de Directie/ASRCP - Savu Sorin Vasile - Foto.jpg",
            downloadTitle: "download_cv_title",
            downloadLinks: [{
                name: "download_name_pdf",
                url: "/DownloadDocuments/Directions/Comitet de Directie/ASRCP - Savu Sorin Vasile - CV.pdf",
            }],
        },
        {
            title: "Grigorof Petru",
            image: "/DownloadDocuments/Directions/Comitet de Directie/ISIM - Grigorof Petru - Foto.jpg",
            downloadTitle: "download_cv_title",
            downloadLinks: [{
                name: "download_name_pdf",
                url: "/DownloadDocuments/Directions/Comitet de Directie/ISIM - Grigorof Petru - CV.pdf",
            }],
        },
        {
            title: "Radu Bogdan",
            image: "/DownloadDocuments/Directions/Comitet de Directie/ISIM - Radu Bogdan - Foto.JPG",
            downloadTitle: "download_cv_title",
            downloadLinks: [{
                name: "download_name_pdf",
                url: "/DownloadDocuments/Directions/Comitet de Directie/ISIM - Radu Bogdan - CV.pdf",
            }],
        },
        {
            title: "Sirbu Alin",
            image: "/DownloadDocuments/Directions/Comitet de Directie/ISIM - Sirbu Alin - Foto.jpg",
            downloadTitle: "download_cv_title",
            downloadLinks: [{
                name: "download_name_pdf",
                url: "/DownloadDocuments/Directions/Comitet de Directie/ISIM - Sirbu Alin - CV.pdf",
            }],
        },
    ];

    return (
        <div className="downloads-page">
            <div className="downloads-grid-title-container">
                <p className="downloads-grid-title">{t("direction_committee_title")}</p>
                <h1 className="downloads-grid-subtitle">{t("direction_committee_subtitle")}</h1>
                <p className="downloads-grid-text">
                    {t("direction_committee_description")}
                </p>
                <ScrollDownIndicator targetId="direction-committee-content" />
            </div>
            <div className="downloads-grid" id="direction-committee-content">
                <DownloadCardGrid downloadCardData={directionCommitteeData} />
            </div>
        </div>
    );
    
}
